import { Dispatch } from 'redux';
import { BestInDental } from './Constants';

export interface IDismissWinnerPopupPayload {
  year: number;
}

export const dismissWinnerPopup = (year: number) => (dispatch: Dispatch) => {
  dispatch({
    type: BestInDental.DISMISS_WINNER_POPUP,
    payload: {
      year,
    } satisfies IDismissWinnerPopupPayload,
  });
};
